import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ImportHistory() {
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  function load() {
    setLoading(true);
    axios.get('/api/imports')
      .then((r) => setImports(r.data?.imports || []))
      .catch((e) => setError(e.response?.data?.error || e.message))
      .finally(() => setLoading(false));
  }
  useEffect(load, []);

  async function handleUndo(id, batch) {
    if (!window.confirm(
      `Undo this import? Will attempt to delete ${batch.record_count} ${batch.record_type}(s).\n\n` +
      `Records that have been modified will be skipped.`
    )) return;
    try {
      const r = await axios.post(`/api/imports/${id}/undo`);
      alert(`Undone: deleted ${r.data.deleted}, skipped ${r.data.skipped} of ${r.data.total}.`);
      load();
    } catch (e) {
      alert(`Undo failed: ${e.response?.data?.error || e.message}`);
    }
  }

  function fmtDate(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString();
  }

  return (
    <section className="page">
      <div className="page-header"><h2>Import History</h2></div>
      {loading && <p>Loading…</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Imported</th>
                <th>Type</th>
                <th>Count</th>
                <th>File</th>
                <th>By</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {imports.length === 0 && <tr><td colSpan="7" className="empty-tab">No imports yet.</td></tr>}
              {imports.map((b) => (
                <tr key={b.id}>
                  <td className="cell-mono">{fmtDate(b.imported_at)}</td>
                  <td>{b.record_type}</td>
                  <td className="cell-mono">{b.record_count}</td>
                  <td className="cell-mono">{b.source_filename || '—'}</td>
                  <td>{b.user_name || '—'}</td>
                  <td>
                    {b.undone_at
                      ? <span className="badge badge-grey">UNDONE ({b.undo_deleted_count}/{b.record_count})</span>
                      : <span className="badge badge-green">ACTIVE</span>}
                  </td>
                  <td>
                    {!b.undone_at && (
                      <button className="btn-secondary btn-sm" onClick={() => handleUndo(b.id, b)}>Undo</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
